import { EAdminPerm } from '@/types/permissions/AdminPermissionsEnum'
import { userHasPermission } from '@/utils/permissionsUtils'
import { computed } from 'vue'
import {
    ADMIN_APIS_ROUTES,
    ADMIN_DEVICE_CONFIGURATION_ROUTE,
    ADMIN_DEVICES_ROUTES,
    ADMIN_ROLES_ROUTES,
    ADMIN_SHUTTLE_EPCS_ROUTES,
    ADMIN_USERS_ROUTES
} from './adminRoutes'
import {
    EAdminApisRoutesValues,
    EAdminDeviceConfigRoutesValues,
    EAdminDevicesRoutesValues,
    EAdminDeviceTemplateKeysRoutesValues,
    EAdminDeviceTemplateRoutesValues,
    EAdminDeviceTypeRoutesValues,
    EAdminRolesRoutesValues,
    EAdminRoutesValues,
    EAdminShuttleEpcsRoutesValues,
    EAdminUsersRoutesValues
} from './AdminRoutesEnum'

export const adminMenu = computed(() => [
    {
        label: 'menu.administration.title',
        icon: 'users-gear',
        permissions: userHasPermission(EAdminPerm.SUPER_ADMIN),
        names: EAdminRoutesValues,
        children: [
            {
                icon: 'user-group',
                label: 'menu.administration.users',
                to: ADMIN_USERS_ROUTES.baseUrl,
                permissions:
                    userHasPermission(EAdminPerm.ADMIN_USERS) ||
                    userHasPermission(EAdminPerm.SUPER_ADMIN),
                names: EAdminUsersRoutesValues
            },
            {
                icon: 'user-tag',
                label: 'menu.administration.roles',
                to: ADMIN_ROLES_ROUTES.baseUrl,
                permissions:
                    userHasPermission(EAdminPerm.ADMIN_ROLES) ||
                    userHasPermission(EAdminPerm.SUPER_ADMIN),
                names: EAdminRolesRoutesValues
            },
            {
                icon: 'microchip',
                label: 'menu.administration.devices',
                to: ADMIN_DEVICES_ROUTES.baseUrl,
                permissions:
                    userHasPermission(EAdminPerm.ADMIN_DEVICES) ||
                    userHasPermission(EAdminPerm.SUPER_ADMIN),
                names: EAdminDevicesRoutesValues
            },
            {
                icon: 'gears',
                label: 'menu.administration.deviceConfiguration',
                to: ADMIN_DEVICE_CONFIGURATION_ROUTE,
                permissions:
                    userHasPermission(EAdminPerm.ADMIN_DEVICES_CONFIG) ||
                    userHasPermission(EAdminPerm.SUPER_ADMIN),
                names: [
                    ...EAdminDeviceConfigRoutesValues,
                    ...EAdminDeviceTypeRoutesValues,
                    ...EAdminDeviceTemplateRoutesValues,
                    ...EAdminDeviceTemplateKeysRoutesValues
                ]
            },
            {
                icon: 'shuttle-space',
                label: 'menu.administration.shuttleEpcs',
                to: ADMIN_SHUTTLE_EPCS_ROUTES.baseUrl,
                permissions: userHasPermission(EAdminPerm.SUPER_ADMIN),
                names: EAdminShuttleEpcsRoutesValues
            },
            {
                icon: 'circle-nodes',
                label: 'menu.administration.api',
                to: ADMIN_APIS_ROUTES.baseUrl,
                permissions:
                    userHasPermission(EAdminPerm.ADMIN_APIS) ||
                    userHasPermission(EAdminPerm.SUPER_ADMIN),
                names: EAdminApisRoutesValues
            }
        ]
    }
])
